module.exports = __webpack_public_path__ + "img/zoom-in.6911e5b2.png";